<template>
  <div class="mb-3">
    <h2 class="fw-light d-flex align-items-center mb-0">
      <router-link
        to="/home"
        class="d-flex align-items-center me-2"
        title="Voltar"
      >
        <i class="ph-caret-circle-left ph-2x" />
      </router-link>
      Contrato, Ordem de Compra, Ordem de Serviço
    </h2>
  </div>
  <div class="card border-start border-start-width-2 border-start-primary">
    <div class="card-body d-flex justify-content-end align-items-center">
      <span>Exibir apenas ativos</span>
      <input
        type="checkbox"
        class="form-check-input mx-2"
        v-model="filters.onlyActive"
      />
      <span class="ms-2">Exibir a partir de</span>
      <input
        type="date"
        class="form-control mx-2 w-25"
        v-model="filters.startDate"
      />
      <button
        type="button"
        class="btn btn-success rounded-pill"
        title="Buscar"
        :disabled="disableButton"
        @click="getContracts"
      >
        <span v-if="disableButton">
          <i class="ph-spinner spinner me-2" />Buscar
        </span>
        <span v-else><i class="ph-magnifying-glass me-2" />Buscar</span>
      </button>
    </div>
  </div>
  <LoadingData v-if="isLoading" />
  <DataTableDefault
    v-else
    :dataTable="dataTable"
    :options="optionsDataTable"
    customClass="table-xs fs-sm"
    @setSearchDataTable="setSearchDataTable"
  />
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import DataTableDefault from '@/components/commons/DataTableDefault.vue'
import { mapGetters } from 'vuex'
import { formatToCurrencyBr } from '@/utils/currency'
import { dateTimeRmToDateBR, dateNowUsOneYearAgo } from '@/utils/date'

export default {
  name: 'ContractsList',

  components: {
    LoadingData,
    DataTableDefault,
  },

  data() {
    return {
      isLoading: true,
      disableButton: false,
      filters: {
        onlyActive: true,
        startDate: dateNowUsOneYearAgo(),
      },
      dataTable: {
        columns: [
          {
            data: 'idContrato',
            title: 'Código',
          },
          {
            data: 'nomeContrato',
            title: 'Contrato',
          },
          {
            data: 'cnpj',
            title: 'CNPJ',
          },
          {
            data: 'fornecedor',
            title: 'Fornecedor',
          },
          {
            data: 'codCCusto',
            title: 'Centro de Custo',
          },
          {
            data: 'dataContrato',
            title: 'Data do Contrato',
          },
          {
            data: 'idFluig',
            title: 'Id Fluig',
          },
          {
            data: 'saldo',
            title: 'Saldo',
          },
          {
            data: 'valorTotal',
            title: 'Valor Total',
          },
          {
            data: 'link',
            title: 'Ações',
            searchable: false,
            orderable: false,
            render(value) {
              return `
              <a href="#" data-item-router="/documents/contracts" data-item-id="${value}" class="badge bg-primary" title="Detalhar">
                Detalhar
              </a>`
            },
          },
        ],
        data: [],
        search: '',
      },
      optionsDataTable: {
        order: [[0, 'desc']],
        columnDefs: [{ targets: [6], className: 'text-center' }],
      },
    }
  },

  computed: {
    ...mapGetters(['previousRouterName', 'contracts']),
  },

  methods: {
    async getContracts() {
      try {
        this.disableButton = true

        const contracts = await this.$store.dispatch('getContracts', {
          startDate: this.filters.startDate,
          onlyActive: this.filters.onlyActive,
        })

        this.dataTable.data = contracts.map((contract) => {
          return {
            idContrato: contract.idContrato,
            nomeContrato: contract.nomeContrato,
            cnpj: contract.cnpj,
            fornecedor: contract.fornecedor,
            codCCusto: contract.codCCusto,
            idFluig: contract.idFluig,
            dataContrato: dateTimeRmToDateBR(contract.dataContrato),
            saldo: formatToCurrencyBr(contract.saldo),
            valorTotal: formatToCurrencyBr(contract.valorTotal),
            link: contract.idContrato,
          }
        })

        this.setContracts()

        this.isLoading = false
        this.disableButton = false
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    setContracts() {
      this.$store.dispatch('setContracts', {
        data: this.dataTable.data,
        filters: {
          onlyActive: this.filters.onlyActive,
          startDate: this.filters.startDate,
          searchDataTable: this.dataTable.search,
        },
      })
    },

    setSearchDataTable(value) {
      this.dataTable.search = value
      this.setContracts()
    },
  },

  mounted() {
    if (this.previousRouterName === 'ContractDetails') {
      this.isLoading = true

      this.filters.onlyActive = this.contracts.filters.onlyActive
      this.filters.startDate = this.contracts.filters.startDate
      this.dataTable.data = this.contracts.data
      this.dataTable.search = this.contracts.filters.searchDataTable

      this.isLoading = false
    } else {
      this.$store.dispatch('resetContracts')
      this.getContracts()
    }
  },
}
</script>
